import {
    FETCH_OFFICES_FAILED, FETCH_OFFICES_SUCCESS, FETCHING_OFFICES,
    FETCHING_MEMBERS, FETCH_MEMBERS_SUCCESS, FETCH_MEMBERS_FAILED
} from "../actions/RosterActions";

export default function reducer(state = {
    offices: [],
    members: [],
    isFetchingOffices: false,
    isFetchingMembers: false,
    officesErr: null,
    membersErr: null,
}, action) {
    switch (action.type) {

        case FETCHING_OFFICES: {
            return { ...state, isFetchingOffices: true };
        }
        case FETCH_OFFICES_SUCCESS: {
            return { ...state, isFetchingOffices: false, offices: action.payload };
        }
        case FETCH_OFFICES_FAILED: {
            return { ...state, isFetchingOffices: false, offices: [], officesErr: action.payload };
        }
        case FETCHING_MEMBERS: {
            return { ...state, isFetchingMembers: true };
        }
        case FETCH_MEMBERS_SUCCESS: {
            return { ...state, isFetchingMembers: false, members: action.payload };
        }
        case FETCH_MEMBERS_FAILED: {
            return { ...state, isFetchingMembers: false, members: [], membersErr: action.payload };
        }
        default:
            break;
    }

    return state;
}